import styled from '@emotion/styled';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #001574 0%, #001c71 100%);
  padding: 24px;
`;

export const StepCard = styled.div`
  background: rgba(255, 255, 255, 0.98);
  border-radius: 20px;
  padding: 32px;
  max-width: 560px;
  margin: 0 auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
`;

export const StepTitle = styled.h2`
  color: #191919;
  margin: 18px 0 8px 0;
  font-size: 1.5rem;
`;

export const StepSubtitle = styled.p`
  color: #5f5f5f;
  margin-bottom: 24px;
  font-size: 0.95rem;
`;

export const AttendanceLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  font-size: 0.875rem;
  color: #5f5f5f;
  .legend-item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
  }
  .status-indicator {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
  }
  .status-date-green {
    background-color: #22c55e;
  }
  .status-date-orange {
    background-color: #ff7f00;
  }
  .status-false {
    background-color: #e5e7eb;
    color: #6b7280;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
  label {
    display: block;
    font-weight: 600;
    color: #191919;
    margin-bottom: 8px;
  }
  .ui.input input {
    width: 100%;
    max-width: 400px;
  }
  &.error .ui.input input {
    border-color: #e74c3c;
  }
`;

export const DateListSection = styled.div`
  margin-top: 20px;
  .step-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 10px 12px;
    background: #f6fbff;
    border-radius: 8px;
    font-size: 1rem;
    color: #5f5f5f;
  }
  .step-item.has-attendance {
    background: #f0fdf4;
  }
  .step-item.no-attendance {
    background: #fff7ed;
  }
  .status-indicator {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin-left: 8px;
  }
  .status-date-orange {
    background-color: #ff7f00;
  }
  .status-date-green {
    background-color: #22c55e;
  }
  .status-false {
    background-color: #e5e7eb;
    color: #6b7280;
  }
`;
